"use client";
import artOrderApi from "@/api/art-order/order/client";
import { ArtOrderGallery } from "@/app/(components)/Application/ArtOrder/ArtOrderGallery";
import { useQuery } from "@tanstack/react-query";

export interface Props {
  orderId: string;
}

const ArtOrderDetails = ({ orderId }: Props) => {
  const { data: artOrder } = useQuery({
    queryKey: ["art-order", orderId],
    queryFn: () => artOrderApi.getArtOrder(orderId),
  });

  return (
    <>
      <div
        className="ql-editor-display"
        dangerouslySetInnerHTML={{
          __html: `<div>${artOrder?.detailedDescription}</div>`,
        }}
      ></div>
      {artOrder?.images?.length && (
        <>
          <div className="flex flex-col gap-y-2 mb-6">
            <span className="text-endemicGray-700 text-xs tracking-wider endemic:text-primary">
              INSPIRATION IMAGES
            </span>
            <div className="bg-endemicGray-500 h-[2px]" />
          </div>
          <ArtOrderGallery images={artOrder.images} />
        </>
      )}
    </>
  );
};

export default ArtOrderDetails;
